export default __webpack_public_path__ + "static/media/Mark-3-HUD-05.93c872ed.jpg";